import { Alert } from 'antd'
import { DISCLAIMER_MESSAGES } from '../../data'

export const ShortDisclaimerAlert = () => {
  return (
    <Alert
      message={DISCLAIMER_MESSAGES.appointmentDisclaimer}
      type='info'
      closable
      showIcon
      className='alert-custom-icon'
      style={{ marginTop: 16 }}
    />
  )
}
